import React from 'react'

function NotFound() {
  return (
    <svg
      width={490}
      height={501}
      viewBox="0 0 490 501"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M357.683 58.63c27.651 24.843 45.747 59.504 74.799 109.325 29.187 49.82 69.434 114.794 54.171 153.529-15.263 38.736-86.307 51.222-153.388 76.624-67.081 25.401-130.235 63.572-188.333 56.131-58.097-7.442-111.137-60.482-124.477-119.144-13.475-58.804 12.627-123.218 31.43-181.881 18.667-58.656 30.034-111.586 62.73-135.55C147.31-6.3 201.346-1.151 247.099 8.809c45.747 10.084 82.934 24.985 110.584 49.821z"
        fill="#F3F5F8"
      />
      <path
        d="M105.122 476.531H85.889v22.778H57.692v-22.778H0v-8.603l66.657-91.1h19.232v75.431h19.233v24.272zm-47.43-24.272v-28.382l-20.16 28.382h20.16zM121.18 438.256c0-35.289 10.267-63.111 46.084-63.111 35.639 0 45.556 27.822 45.556 63.111 0 35.104-9.892 62.736-45.556 62.736-35.817 0-46.084-27.632-46.084-62.736zm63.48 0c0-21.285-4.111-37.716-17.365-37.716-13.444 0-18.108 16.431-18.108 37.716 0 21.094 4.664 37.156 18.108 37.156 13.254.025 17.365-16.062 17.365-37.156z"
        fill="#4D4D4D"
      />
      <path d="M329.806 477.098h10.452v-8.849h-10.452v8.849z" fill="#B3B3B3" />
      <path
        d="M341.242 475.715v8.848h-24.867v-3.22l12.934-5.628h11.933z"
        fill="#000"
      />
      <path d="M167.341 368.547h10.452v-8.848h-10.452v8.848z" fill="#B3B3B3" />
      <path
        d="M178.779 367.168v8.848h-24.861v-3.213l12.934-5.635h11.927z"
        fill="#000"
      />
      <path
        d="M329.444 248.828c.528 5.026 11.632 221.753 11.632 221.753h-11.632l-56.561-204.063 56.561-17.69z"
        fill="#C01414"
      />
      <path
        d="M335.415 224.954c0 29.433-10.82 55.916-32.726 55.916-30.072 0-69.882-19.171-80.838-29.992-2.735 8.087-41.519 109.94-41.519 109.94H164.27s10.292-118.591 29.586-149.007c6.347-8.455 58.146-6.341 84.316 0s57.243 13.143 57.243 13.143z"
        fill="#D62929"
      />
      <path
        d="M328.798 476.531h-19.232v22.778h-28.192v-22.778h-57.71v-8.603l66.669-91.1h19.233v75.431h19.232v24.272zm-47.424-24.272v-28.382l-20.166 28.382h20.166z"
        fill="#4D4D4D"
      />
      <path
        d="M257.743 53.462a3.777 3.777 0 014.018-3.023c2.354.166 6.2 6.384 6.2 11.416 0 5.033-1.419 6.926-.989 10.581.43 3.657 9.739 53.231 9.739 56.254 2.347.166 10.747-1.007 10.747-1.007l-5.88 23.681h-17.119l-11.061-95.383 4.345-2.519z"
        fill="#737373"
      />
      <path
        d="M274.158 61.904l-3.607 14.575s-35.583-4.135-39.466-5.094c-3.884-.958 1.966-25.058 5.954-24.075 3.988.984 37.119 14.594 37.119 14.594z"
        fill="#000"
      />
      <path
        d="M306.763 105.02c45.519 0 34.293 117.601 28.978 122.001-5.316 4.399-61.907-10.446-66.608-16.996-4.701-6.55 4.246-105.005 37.63-105.005z"
        fill="#4D4D4D"
      />
      <path
        d="M290.518 134.879c-2.501.848-17.168 6.569-17.168 6.569-.246-2.949-11.521-61.446-12.215-65.028a29.258 29.258 0 002.07-11.245c0-9.604-3.901-17.402-8.713-17.402-4.811 0-8.707 7.798-8.707 17.402-.068 4.02.707 8.01 2.274 11.712-.541 7.312-5.395 76.74 4.51 86.639 10.446 10.445 35.842 1.026 51.277-5.991 3.306-1.143-1.198-25.937-13.328-22.656z"
        fill="#B3B3B3"
      />
      <path
        d="M279.627 67.925l-9.205-2.444-1.708 6.431 9.205 2.444 1.708-6.431z"
        fill="#000"
      />
      <path
        d="M335.774 126.625c6.937 13.469-20.536 37.734-28.137 35.928-7.6-1.807-19.859-28.929-17.567-33.796 2.292-4.866 38.957-15.238 45.704-2.132z"
        fill="#646363"
      />
      <path
        d="M309.554 116.422c0 2.279-13.906 2.857-13.906 0v-26.25h13.906v26.25z"
        fill="#B3B3B3"
      />
      <path
        d="M297.577 105.409c10.025 0 18.151-13.142 18.151-29.353 0-16.211-8.126-29.353-18.151-29.353s-18.151 13.142-18.151 29.353c0 16.211 8.126 29.353 18.151 29.353z"
        fill="#B3B3B3"
      />
      <path
        d="M283.979 56.61a11.91 11.91 0 005.377 10.754c5.413 3.686 9.272 2.058 13.241 5.53 2.096 2.095 7.226 6.144 7.276 12.4 0 4.627 1.517 6.961 2.851 6.961 1.333 0 4.848-.921 7.109-.921 22.207 0 48.284 22.925 98.314 22.925 26.133 0 67.142-6.593 67.142-44.972 0-20.726-7.46-45.771-46.89-45.771-25.039 0-42.582 12.289-63.154 12.289-26.422 0-36.61-9.567-54.865-9.567-13.002 0-42.263 7.533-42.263 27.27 0 7.496 2.347 9.671 3.072 10.058.234-.823 1.666-5.075 2.79-6.956z"
        fill="#000"
      />
      <path
        d="M308.004 87.637a4.633 4.633 0 100-9.266 4.633 4.633 0 000 9.266z"
        fill="#B3B3B3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M288.191 89.263c.424.181.581.599.351.933-.473.689-1.181 1.414-1.946 1.995-.734.558-1.653 1.084-2.565 1.203-.475.063-.924-.19-1.003-.566-.079-.375.242-.73.717-.791.37-.049.967-.325 1.642-.838.645-.49 1.241-1.103 1.622-1.659.23-.334.759-.458 1.182-.277z"
        fill="#1F161E"
      />
      <ellipse cx={283.017} cy={74.397} rx={1.408} ry={2.112} fill="#0D0D0D" />
      <path
        d="M283.721 84.957c1.167 0 2.113-.63 2.113-1.408 0-.778-.946-1.408-2.113-1.408-1.166 0-2.112.63-2.112 1.408 0 .777.946 1.408 2.112 1.408z"
        fill="#FA9E9F"
      />
    </svg>
  )
}

export default React.memo(NotFound)
